<template>
  <iMineTemplate
    :pageTitle="pageTitle"
    :activedParentKey="activedParentKey"
    :activedKey="activedKey"
  >
    <template #rightContent>
      <div class="storeinfo">
        <div class="title" style="position:relative;">
          <span>子账号管理</span>
          <div class="add-tips">
            <van-icon
              name="info-o"
            />子账号适应于一个门店有多人采购。比如：老板、老板娘、店长等场景，一个门店下最多可添加{{maxSubCount}}个子账号。
          </div>
        </div>
        <div class="content">
          <!-- table -->
          <table
            class="account-list"
            style="border-collapse:separate; border-spacing:0px 12px;"
            v-if="accountList.length"
          >
            <thead>
              <tr>
                <td class="item-title" width="178">姓名</td>
                <td width="101">职务</td>
                <td>联系电话</td>
                <td class="do-col">操作</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in accountList" :key="item.Id">
                <td class="item-title">{{ item.AccountName }}</td>
                <td>{{ item.AccountRoleType }}</td>
                <td>{{ item.AccountPhone }}</td>
                <td class="do-row">
                  <span class="del-btn" @click.stop="delAccount(item.Id)"
                    >删除</span
                  >
                  <span class="edit-btn" @click.stop="editAccount(item.Id)"
                    >编辑</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
          <!-- 空数据提示 -->
          <div class="empty-tips" v-else>
            <img
              src="../../assets/empty/no-child-account.png"
              alt=""
              class="emtyp-tips-img"
            />
          </div>
          <!-- add btn -->
          <van-button
            @click.stop="toAddAccount"
            icon="plus"
            type="primary"
            class="add-btn"
            :class="{ 'dis-plus': accountList.length >= maxSubCount }"
            >添加子账号</van-button
          >
        </div>
      </div>
    </template>
  </iMineTemplate>
</template>

<script>
import { BaseMixin } from '@/mixins/BaseMixin'
export default {
  mixins: [BaseMixin],
  name: 'ChildAccount',
  data() {
    return {
      pageTitle: ['我的账户', '子账号管理'],
      activedParentKey: 1,
      activedKey: 51,
      accountList: [],
      maxSubCount: 0, // 用户最多可添加子账号数
      url: {
        CustomerContactDetail: '/api_customers/Customer/CustomerContactDetail',
      },
    }
  },
  mounted() {
    this.getAccountList()
    this.getMaxSubCount()
  },
  methods: {
    async toDelAccount(Id) {
      const res = await this.deleteAction(
        `/api_customer/ChildAccount/DelAccountById?accountId=${Id}`
      )
      if (res.IsSuccess) {
        // 删除成功
        this.$toast({
          position: 'bottom',
          message: '删除成功',
          onClose: () => {
            this.getAccountList()
          },
        })
      }
    },
    async delAccount(id) {
      try {
        this.$dialog
          .confirm({
            title: '提示',
            message: '删除后不可恢复请谨慎操作',
            confirmButtonColor: '#0F6EEA',
            confirmButtonText: '确定',
          })
          .then(() => {
            this.toDelAccount(id)
          })
          .catch(() => {
            // on cancel
          })
      } catch (error) {
        console.log(error)
      }
    },
    async getAccountList() {
      try {
        const res = await this.getAction(
          '/api_customer/ChildAccount/GetAccountList'
        )
        this.accountList = res.Data
      } catch (error) {
        console.log(error)
      }
    },
    // 获取用户最多可添加子账号数
    async getMaxSubCount() {
      const res = await this.getAction(
        '/api_customer/ChildAccount/GetMaxSubCount'
      )
      this.maxSubCount = res.Data || 3
    },
    editAccount(accountId) {
      const { maxSubCount = 3 } = this
      this.$router.push({
        path: '/AddChildAccount',
        query: { accountId, maxSubCount },
      })
    },
    toAddAccount() {
      const { accountList, maxSubCount } = this
      if (accountList.length >= maxSubCount) {
        this.$toast({
          message: `最多可添加${maxSubCount}个子账号 如需添加更多，请联系客服申请`,
        })
      } else {
        this.$router.push({ path: '/AddChildAccount', query: { maxSubCount } })
      }
    },
  },
}
</script>
<style lang="less" scoped>
.storeinfo {
  margin: 0 20px 20px 0;
  width: 940px;
  padding: 20px;
  min-height: 680px;
  font-size: 16px;
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  border: 1px solid rgba(232, 232, 232, 1);
  // padding: 20px;
  position: relative;
  box-sizing: border-box;
  .add-tips {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #0f6eea;
    padding-left: 16px;
    .van-icon {
      margin-right: 4px;
    }
  }

  .title {
    width: 898px;
    height: 42px;
    border-bottom: 1px solid #e8e8e8;
    line-height: 22px;

    span {
      float: left;
      font-size: 18px;
      color: rgba(34, 34, 34, 1);
    }
  }

  .content {
    text-align: left;
    width: 898px;
    padding: 0;
    font-weight: 400;
    line-height: 40px;
    box-sizing: border-box;
    .account-list {
      width: 100%;
      .item-title {
        padding-left: 24px;
      }
      thead tr {
        background-color: #f0f3f5;
        border-radius: 4px;
      }
      tr {
        background: #f9fafb;
        border-radius: 4px;
        color: #111a34;
        font-size: 14px;
      }
      .do-col {
        text-align: center;
      }
      .do-row {
        text-align: center;
        span {
          cursor: pointer;
        }
      }
      .del-btn {
        color: #666f83;
        font-size: 14px;
      }
      .edit-btn {
        color: #0f6eea;
        font-size: 14px;
        padding-left: 24px;
      }
    }
    .empty-tips {
      text-align: center;
      margin-bottom: 50px;
      margin-top: 100px;
    }
    .add-btn {
      display: block;
      width: 200px;
      height: 40px;
      border-radius: 4px;
      border: 1px solid #0f6eea;
      background-color: #ffffff;
      color: #0f6eea;
      margin: 0 auto;
      &.dis-plus {
        background: #f0f3f5;
        color: #858b9c;
        border-color: #f0f3f5;
        &:active {
          background-color: #f0f3f5;
          color: #858b9c;
        }
      }
      &:active {
        background-color: #0f6eea;
        color: #ffffff;
      }
    }
  }
}
</style>
